module.exports = __webpack_public_path__ + "assets/img/as1.baeb3018.jpg";